import home from './src/home.vue'
import ChimneyEquipView from './src/chimneyEquipment/ChimneyEquipView.vue'
import ChimneyEquipInfo from './src/chimneyEquipment/ChimneyEquipInfo.vue'

let views = {
    home,
    ChimneyEquipView,
    ChimneyEquipInfo
};

export default views;
